import { system } from './system.js';
import { http } from './http.js';
import { models } from './models.js';
import { api } from './api.js';

var providers = {
    paypal: 'paypal',
    isAllowed: function (name) {
        if (!name) { return false; }
        return name.toLowerCase() === "paypal";
    }
};

function formatPrice(price, currencyId, currencySymbol) {
    if (typeof price === "undefined" || price === null || isNaN(price)) {
        price = 0.00;
    }

    if (!currencyId) {
        currencyId = "USD";
    }

    var symbol = currencySymbol ? " (" + currencySymbol + ")" : "";
    return price.toFixed(2) + " " + currencyId + symbol;
}

// Claim a discount
function claimDiscount(customerId, orderId, discountCode) {
    var dfd = system.deferred();

    console.group('Shop claim discount started');

    if (typeof customerId === "undefined" || customerId === null || !system.isUuid(customerId)) {
        console.warn('Invalid customerId', { customerId: customerId, orderId: orderId, discountCode: discountCode });
        return dfd.reject().promise();
    }

    if (typeof orderId === "undefined" || orderId === null || !system.isUuid(orderId)) {
        console.warn('Invalid orderId', { customerId: customerId, orderId: orderId, discountCode: discountCode });
        return dfd.reject().promise();
    }

    if (typeof discountCode === "undefined" || discountCode === "") {
        console.warn('Invalid discountCode', { customerId: customerId, orderId: orderId, discountCode: discountCode });
        return dfd.reject().promise();
    }

    http.post(api.resources.applyOrderDiscount, new models.OrderDiscount({ customerId: customerId, orderId: orderId, discountCode: discountCode }))
        .done(function (response) {
            dfd.resolve(new models.OrderDiscount(response));
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            console.warn("POST Failed", { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
            dfd.reject();
        })
        .always(function () {
            console.groupEnd();
        });

    return dfd.promise();
}

// Unclaim a discount
function unclaimDiscount(customerId, orderId) {
    var dfd = system.deferred();

    console.log("Shop unclaim discount started");

    if (typeof customerId === "undefined" || customerId === null || !system.isUuid(customerId)) {
        console.warn('Invalid customerId', { customerId: customerId, orderId: orderId });
        return dfd.reject().promise();
    }

    if (typeof orderId === "undefined" || orderId === null || !system.isUuid(orderId)) {
        console.warn('Invalid orderId', { customerId: customerId, orderId: orderId });
        return dfd.reject().promise();
    }

    http.post(api.resources.removeOrderDiscount, { customerId: customerId, orderId: orderId })
        .done(function (response) {
            dfd.resolve(new models.OrderDiscount(response));
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            console.warn("DELETE Failed", { jqXHR: jqXHR, textStatus: textStatus, errorThrown: errorThrown });
            dfd.reject();
        })
        .always(function () {
            console.groupEnd();
        });

    return dfd.promise();
}

function purchaseWithPaypal(orderId) {
    window.location.href = api.resources.paypal + '/' + orderId;
}

// Starts a purchase flow
function purchase(provider, orderId, productId, productUrl) {
    console.log("Shop purchase flow started", { provider: provider, orderId: orderId, productId: productId });

    var dfd = system.deferred();

    if (!providers.isAllowed(provider)) {
        console.warn('Invalid provider, cancelling purchase', provider, orderId, productId);
        dfd.reject();
        return dfd.promise();
    }

    if (typeof orderId === "undefined" || orderId === null || !system.isUuid(orderId)) {
        console.warn('Invalid orderId, cancelling purchase', provider, orderId, productId);
        dfd.reject();
        return dfd.promise();
    }

    if (typeof productId === "undefined" || productId === null || !system.isUuid(productId)) {
        console.warn('Invalid productId, cancelling purchase', provider, orderId, productId);
        dfd.reject();
        return dfd.promise();
    }

    switch (provider) {
        case providers.paypal:
            purchaseWithPaypal(orderId);
            break;
        default:
            console.error('Provider is not allowed or supported', orderId, productId);
            break;
    }

    return dfd.promise();
}

function deliver(orderId) {
    var dfd = system.deferred();

    if (typeof orderId === "undefined" || orderId === null || !system.isUuid(orderId)) {
        console.warn('Invalid orderId, cancelling deliver', orderId);
        dfd.reject();
        return dfd.promise();
    }

    console.log("Shop purchase deliver ", { orderId: orderId });
    window.location = api.resources.deliver + "/" + orderId;
}

export const shop = {
    formatPrice: formatPrice,
    claimDiscount: claimDiscount,
    unclaimDiscount: unclaimDiscount,
    purchase: purchase,
    deliver: deliver
};